<template>
	<div class="CvView view vhSpace vhSpace--large">
		
		<template v-if="app.gui.view == 'CvIntro'">		
			<CvIntro></CvIntro>
		</template>
		<template v-if="app.gui.view == 'CvSheet'">		
			<CvSheet></CvSheet>		
		</template>
		
	</div>
</template>

<script>
	// @ is an alias to /src	
	import { EventBus } from '@/event-bus.js'
	import CvIntro from '@/components/CvIntro.vue'
	import CvSheet from '@/components/CvSheet.vue'

	export default {
		name: 'CvView',
		components: {
			CvIntro,
			CvSheet,
		},
		mixins: [],
		directives: {},
		props: {
		},
		data() {
			return {
				page: {},
			}
		},
		computed: {
			app() {
				return this.$root.$children[0]
			},
		},
		methods: {},
		mounted() {},
	}
</script>

<style lang="less">
	.CvView {
		display: flex;
		flex-direction: column;
		justify-content: center;
	}
</style>
